const moduleCheckoutTokenSel = (state: any) => state.paySimpleCheckoutToken;

export const checkoutTokenSel = (state: any) =>
  moduleCheckoutTokenSel(state).JwtToken;
export const expirationDateSel = (state: any) =>
  moduleCheckoutTokenSel(state).Expiration;
export const urlDataSel = (state: any) => moduleCheckoutTokenSel(state).url;
export const isPendingSel = (state: any) =>
  moduleCheckoutTokenSel(state).isPending;
export const errorSel = (state: any) => moduleCheckoutTokenSel(state).error;
